
import camelCase from 'lodash/camelCase';

const dynamicModules = {};
const files = require.context('.', true, /\.js$/);


files.keys().filter(file => file != './index.js').forEach(file => {
    const moduleName = camelCase(file.replace(/(\.\/|\.js)/g, ''))
    dynamicModules[moduleName] = {
        ...files(file).default
    }
})

// ./ums/admin/add-edit-dialog => umsAdminAddEditDialog
export default dynamicModules;


// WEBPACK FOOTER //
// ./src/store/modules/index.js